import { useState, useEffect } from 'react';

export const useClubData = (handle, databaseUrl) => {
  const [clubData, setClubData] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedGuide, setSelectedGuide] = useState(null);
  const [selectedHole, setSelectedHole] = useState(1);

  useEffect(() => {
    const getClubInformation = async () => {
      const url = `${databaseUrl}/${handle}`;
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setClubData(data);
        setLoading(false);
        if (data.guides.length > 0) {
          const firstValidGuide = data.guides.find(
            (guide) => guide.holes.length > 0
          );
          if (firstValidGuide) {
            setSelectedGuide(firstValidGuide);
          } else {
            setSelectedGuide(null);
          }
        }
      } catch (error) {
        console.error("Could not fetch the club data:", error);
      }
    };

    getClubInformation();
  }, [handle, databaseUrl]);

  useEffect(() => {
    if (clubData.name) {
      document.title = `GLFR  - ${clubData.name}`;
    }
  }, [clubData.name]);

  return {
    clubData,
    loading,
    selectedGuide,
    setSelectedGuide,
    selectedHole,
    setSelectedHole
  };
}; 